/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_Image_HintInputs */

const vi_shop_home_hero_image_hint = /** @type {(inputs: Shop_Home_Hero_Image_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khung ngang khoảng 16:9.`)
};

/**

* @param {Shop_Home_Hero_Image_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_image_hint = /** @type {((inputs?: Shop_Home_Hero_Image_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_Image_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_image_hint(inputs)
});